import { NgStyle } from "@angular/common";
import { Component, ContentChild, ElementRef, HostListener, Input, ViewChild, ViewContainerRef } from "@angular/core";
import { DialogActionsDirective } from "./dialog-actions.directive";
import { DialogContentDirective } from "./dialog-content.directive";
import { DialogTitleDirective } from "./dialog-title.directive";

@Component({
    selector: '[stDialog]',
    template: `
        <section class="padded-content container" style="background-color: {{bgColorClass}};" [ngStyle]="{ 'text-align': textCenter ? 'center' : 'start' }">
            <header>
                <ng-container #titleVcr></ng-container>
            </header>
            <main>
                <ng-container #contentVcr></ng-container>
            </main>
            <footer [ngStyle]="dialogActionsStyle">
                <ng-container #actionsVcr></ng-container>
            </footer>
        </section>
    `,
})
export class DialogComponent {
    @ContentChild(DialogContentDirective) content: DialogContentDirective;
    @ContentChild(DialogTitleDirective) header: DialogTitleDirective;
    @ContentChild(DialogActionsDirective) footer: DialogActionsDirective;

    @ViewChild('contentVcr', { read: ViewContainerRef, static: true })
    private contentVcr: ViewContainerRef;

    @ViewChild('titleVcr', { read: ViewContainerRef, static: true })
    private titleVcr: ViewContainerRef;

    @ViewChild('actionsVcr', { read: ViewContainerRef, static: true })
    private actionsVcr: ViewContainerRef;

    @Input() bgColor: 'white' | 'lightGray';
    @Input() textCenter: boolean;
    @Input() disableClose: boolean;

    @Input() dialogActionsStyle: NgStyle;

    get bgColorClass() {
        switch (this.bgColor) {
            case 'white':
                return '#fff';
            case 'lightGray':
                return '#F1F1F1';
            default:
                return '#fff';
        }
    }

    private get element() {
        return this.host.nativeElement;
    }

    constructor(private host: ElementRef) { }

    openModal() {
        this.host.nativeElement.showModal();
        this.contentVcr.createEmbeddedView(this.content.tpl);
        this.header?.tpl && this.titleVcr.createEmbeddedView(this.header.tpl);
        this.footer?.tpl && this.actionsVcr.createEmbeddedView(this.footer.tpl);
    }

    closeModal() {
        this.element.addEventListener(
            'animationend',
            (e: AnimationEvent) => {
                if (e.animationName === 'fadeOut') {
                    this.element.close();
                    this.clear();
                    this.element.removeAttribute('closing');
                }
            },
            { once: true }
        );

        this.element.setAttribute('closing', 'true');
    }

    private clear() {
        this.contentVcr.clear();
        this.actionsVcr.clear();
        this.titleVcr.clear();
    }

    @HostListener('click', ['$event'])
    onDialogClick(event: MouseEvent) {
        if ((event.target as any).nodeName === 'DIALOG') {
            if (this.disableClose)
                return;
            this.closeModal();
        }
    }

    @HostListener('cancel', ['$event'])
    onDialogCancel(event: KeyboardEvent) {
        if ((event.target as any).nodeName === 'DIALOG') {
            if (this.disableClose) {
                event.preventDefault();
                return;
            }
            this.clear();
        }

    }
}